import * as s from './selectors';

export const SHOW = 'map.show';
export const HIDE = 'map.hide';

export function show(mapId) {
    return {type: SHOW, payload: mapId};
}

export function hide(mapId) {
    return {type: HIDE, payload: mapId};
}

export function toggle(mapId) {
    return function (dispatch, getState) {
        const action = s.isShown(getState(), mapId) ? hide : show;

        return dispatch(action(mapId));
    };
}
